import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  CircularProgress,
  Avatar,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  Close,
  Edit,
  FilterList,
  Settings as SettingsIcon,
  AccountCircle,
  CheckCircle,
  Storage,
  ColorLens,
  Block,
  KeyboardArrowRight,
  Cached,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { Skeleton, Autocomplete, Pagination } from "@material-ui/lab";

import { makeStyles, useTheme } from "@material-ui/styles";
import {
  FinanceService,
  AdminService,
  Validator,
} from "../../../../utils/web_config";

import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function ServiceRegistry(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [registries, setRegistries] = useState({
    loading: false,
    saving: false,
    open: false,
    token: {},
    data: [],
  });

  const [token, setToken] = useState({
    saving: false,
    open: false,
    data: {},
  });
  const [discoveries, setDiscoveries] = useState({
    loading: false,
    saving: false,
    open: false,
    page: 0,
    pages: 1,
    count: 20,
    per_page: 20,
    data: [],
  });

  const [serviceName, setName] = useState({ value: "", error: "" });
  const [serviceEndPoint, setEndPoint] = useState({ value: "", error: "" });
  const [serviceDescription, setDescription] = useState({
    value: "",
    error: "",
  });
  const [serviceVersion, setVersion] = useState({ value: "", error: "" });
  const [serviceKey, setKey] = useState({ value: "", error: "" });

  /////////////
  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getRegistries(accountData.token);
    getDiscoveries(accountData.token);
  }, []);

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  /////////////////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_name")
            }
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onEndPointChange = (event) => {
    if (event.target.value === "") {
      setEndPoint({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_end_point")
            }
          </Translate>
        ),
      });
    } else {
      setEndPoint({ value: event.target.value, error: "" });
    }
  };
  const onDescriptionChange = (event) => {
    if (event.target.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_description")
            }
          </Translate>
        ),
      });
    } else {
      setDescription({ value: event.target.value, error: "" });
    }
  };
  const onVersionChange = (event) => {
    if (event.target.value === "") {
      setVersion({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_version")
            }
          </Translate>
        ),
      });
    } else {
      setVersion({ value: event.target.value, error: "" });
    }
  };
  const onKeyChange = (event) => {
    if (event.target.value === "") {
      setKey({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_key")
            }
          </Translate>
        ),
      });
    } else {
      setKey({ value: event.target.value, error: "" });
    }
  };
  ////////////////////////////

  const onCreateClick = () => {
    if (serviceName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_name")
            }
          </Translate>
        ),
      });
    } else if (serviceEndPoint.value === "") {
      setEndPoint({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_end_point")
            }
          </Translate>
        ),
      });
    } else if (!new Validator().validUrl(serviceEndPoint.value)) {
      setEndPoint({
        value: serviceEndPoint.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "service_registry.forms.hints.service_end_point_invalid"
              )
            }
          </Translate>
        ),
      });
    } else if (serviceDescription.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_description")
            }
          </Translate>
        ),
      });
    } else if (serviceVersion.value === "") {
      setVersion({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_version")
            }
          </Translate>
        ),
      });
    } else if (serviceKey.value === "" && !registries.edit) {
      setKey({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("service_registry.forms.hints.service_key")
            }
          </Translate>
        ),
      });
    } else {
      createRegistry();
    }
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }

    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  ///////////////////////////////

  const createRegistry = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    var url = new AdminService().CREATE_NEW_REGISTRY;
    var data = {
      description: serviceDescription.value,
      end_point: serviceEndPoint.value,
      name: serviceName.value,
      service_category: "EXTERNAL_SYSTEM",
      service_key: serviceKey.value,
      service_type: "EXTERNAL",
      service_version: serviceVersion.value,
    };
    if (registries.edit) {
      updateRegistry(data);
      return;
    }
    setRegistries({ ...registries, saving: true });

    console.log("Creating registry .....");

    createInstance
      .post(url, data)
      .then(function (response) {
        console.log(response.data);
        setRegistries({ ...registries, saving: false, open: false });
        var d = response.data;
        getRegistries(accountData.token);

        setRegistries({
          ...registries,
          open: false,
        });

        setToken({ ...token, open: true, data: d.data });

        setName({ value: "", error: "" });
        setDescription({ value: "", error: "" });
        setVersion({ value: "", error: "" });
        setKey({ value: "", error: "" });
        setEndPoint({ value: "", error: "" });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setRegistries({ ...registries, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////

  const updateRegistry = (data) => {
    const upInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setRegistries({ ...registries, saving: true });

    console.log("Updating registry.....");

    upInstance
      .put(
        new AdminService().UPDATE_REGISTRY +
          registries.selected.service_registry_id,
        data
      )
      .then(function (response) {
        setRegistries({ ...registries, saving: false });

        var d = response.data;

        var regs = registries.data;

        regs[registries.index] = d.data;
        setRegistries({
          ...registries,
          data: regs,
          selected: d.data,
          open: false,
          edit: false,
        });

        setName({ value: "", error: "" });
        setDescription({ value: "", error: "" });
        setVersion({ value: "", error: "" });
        setKey({ value: "", error: "" });
        setEndPoint({ value: "", error: "" });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setRegistries({ ...registries, saving: false });

        var e = error.message;

        console.log(error);
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////

  const refreshToken = () => {
    const reInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setToken({ ...token, saving: true });

    console.log("refreshing.....");

    reInstance
      .put(
        new AdminService().UPDATE_REGISTRY_TOKEN +
          registries.selected.service_registry_id
      )
      .then(function (response) {
        setToken({ ...token, saving: false });

        var d = response.data;
        setToken({
          ...token,
          open: true,
          data: d.data,
        });

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setToken({ ...token, saving: false });

        var e = error.message;

        console.log(error);
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////////

  const toggleRegistryStatus = (id, index, status) => {
    const commInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    var reg = registries.data[index];
    var reg2 = reg;

    console.log("toggling commission .....");

    var url;
    if (status == "ENABLED") {
      url = new AdminService().DEACTIVATE_SERVICE_REGISTRY + id;
      reg["service_status"] = "DISABLED";
    } else {
      url = new AdminService().REACTIVATE_SERVICE_REGISTRY + id;
      reg["service_status"] = "ENABLED";
    }

    var regs = registries.data;

    regs[index] = reg;
    setRegistries({ ...registries, data: regs, toggling: index });

    commInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setRegistries({ ...registries, toggling: null });

        notify("success", d.message);
      })
      .catch(function (error) {
        reg2["service_status"] = status;

        regs[index] = reg2;

        setRegistries({ ...registries, data: regs, toggling: null });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////
  const getRegistries = (token) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
    setRegistries({ ...registries, loading: true });
    console.log("getting registries.....");

    usersInstance
      .get(new AdminService().GET_SERVICE_REGISTRIES)
      .then(function (response) {
        setRegistries({ ...registries, loading: false });
        const d = response.data;
        setRegistries({ ...registries, data: d.data });
      })
      .catch(function (error) {
        setRegistries({ ...registries, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////
  const getDiscoveries = (token, p = 0) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
    setDiscoveries({ ...discoveries, loading: true, page: p });
    console.log("getting discoveries.....");

    usersInstance
      .get(
        new AdminService().GET_SERVICE_DISCOVERY_LIST +
          "?page=" +
          p +
          "&size=" +
          discoveries.per_page
      )
      .then(function (response) {
        setDiscoveries({ ...discoveries, loading: false });
        const d = response.data;
        setDiscoveries({
          ...discoveries,
          data: d.data,
          page: d.current_page,
          count: d.total_items,
          pages: d.total_pages,
        });
      })
      .catch(function (error) {
        setDiscoveries({ ...discoveries, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Dialog
        open={token?.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        scroll="body"
        onClose={() => setToken({ ...token, open: false })}
      >
        <DialogTitle id="alert-dialog-title">
          {"Service credentials"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The service key and token you can use to connect to this system
          </DialogContentText>
          <List>
            <ListItem key={1}>
              <ListItemText
                primary="Service key"
                secondary={token?.data?.service_key}
              />
            </ListItem>
            <Divider variant="middle" />
            <ListItem key={2}>
              <ListItemText
                primary="Service token"
                secondary={token?.data?.service_token}
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setToken({ ...token, open: false })}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* //////////////////////// */}

      <Dialog
        open={registries.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
        onClose={() => setRegistries({ ...registries, open: false })}
      >
        <DialogTitle id="alert-dialog-title">
          {"New external service"}
        </DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={serviceName.value}
                  placeholder={translate(
                    "service_registry.forms.hints.service_name"
                  )}
                  label={
                    <Translate id="service_registry.forms.labels.service_name" />
                  }
                  fullWidth
                  onChange={onNameChange}
                  helperText={serviceName.error}
                  error={serviceName.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={serviceEndPoint.value}
                  placeholder={translate(
                    "service_registry.forms.hints.service_end_point"
                  )}
                  label={
                    <Translate id="service_registry.forms.labels.service_end_point" />
                  }
                  fullWidth
                  onChange={onEndPointChange}
                  helperText={serviceEndPoint.error}
                  error={serviceEndPoint.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  rows={3}
                  rowsMax={7}
                  multiline
                  value={serviceDescription.value}
                  placeholder={translate(
                    "service_registry.forms.hints.service_description"
                  )}
                  label={
                    <Translate id="service_registry.forms.labels.service_description" />
                  }
                  fullWidth
                  onChange={onDescriptionChange}
                  helperText={serviceDescription.error}
                  error={serviceDescription.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  value={serviceVersion.value}
                  placeholder={translate(
                    "service_registry.forms.hints.service_version"
                  )}
                  label={
                    <Translate id="service_registry.forms.labels.service_version" />
                  }
                  fullWidth
                  onChange={onVersionChange}
                  helperText={serviceVersion.error}
                  error={serviceVersion.error !== ""}
                />
              )}
            </Translate>
          </Box>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  disabled={registries.edit}
                  value={serviceKey.value}
                  placeholder={translate(
                    "service_registry.forms.hints.service_key"
                  )}
                  label={
                    <Translate id="service_registry.forms.labels.service_key" />
                  }
                  fullWidth
                  onChange={onKeyChange}
                  helperText={
                    registries.edit
                      ? "Service key can't be edited"
                      : serviceKey.error
                  }
                  error={serviceKey.error !== ""}
                />
              )}
            </Translate>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setRegistries({ ...registries, open: false })}
            color="primary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onCreateClick();
            }}
            disabled={registries.saving}
            color="primary"
            disableElevation
            variant="contained"
            autoFocus
          >
            {registries.saving ? (
              <CircularProgress size={23} />
            ) : registries.edit ? (
              "Save"
            ) : (
              <Translate id="commissions.forms.buttons.create" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ////////////////////////// */}
      <Box display="flex">
        <Box mr={2}>
          <Storage color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Service registry and discovery</b>
        </Typography>
        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          startIcon={<Add />}
          disableElevation
          onClick={() => setRegistries({ ...registries, open: true })}
        >
          New service
        </Button>
      </Box>
      <Grid container spacing={1} justify="center">
        <Grid item xs={12}>
          <Box m={2}>
            <Typography>You can check system health here</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper className={classes.paper} elevation={0}>
            <Box flexGrow={1}>
              <Typography variant="h5">Service registry</Typography>
            </Box>
            <List>
              {!registries.loading
                ? registries.data.map((re, i) => (
                    <ListItem
                      key={i}
                      selected={registries.index == i}
                      button
                      onClick={() => {
                        setRegistries({
                          ...registries,
                          index: i,
                          selected: re,
                        });
                        // getPrivileges(accountData.token, role.role_id);
                      }}
                    >
                      <ListItemIcon>
                        <Storage />
                      </ListItemIcon>
                      <ListItemText
                        primary={re.name}
                        secondary={re.description}
                      />
                      <ListItemSecondaryAction>
                        <Switch
                          color="primary"
                          checked={re.service_status == "ENABLED"}
                          value={i}
                          disabled={registries.toggling == i}
                          onChange={() => {
                            toggleRegistryStatus(
                              re.service_registry_id,
                              i,
                              re.service_status
                            );
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))
                : [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemIcon>
                        <Skeleton variant="circle" width={20} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))}
            </List>
          </Paper>
        </Grid>
        {registries.selected != null ? (
          <Grid item xs={12} md={5}>
            <Box>
              <Box ml={2} mb={2} display="flex" width={1} alignItems="center">
                <Box flexGrow={1}>
                  <Typography variant="h6">
                    {registries.selected.name}
                  </Typography>
                  <Typography color="textSecondary">
                    {registries.selected.description}
                  </Typography>
                </Box>

                <IconButton
                  onClick={() =>
                    setRegistries({
                      ...registries,
                      selected: null,
                      index: null,
                    })
                  }
                >
                  <Close />
                </IconButton>
              </Box>

              <Box display="flex">
                <Button
                  className={classes.btn}
                  startIcon={<Edit />}
                  color="primary"
                  variant="outlined"
                  disableElevation
                  onClick={() => {
                    setRegistries({
                      ...registries,
                      open: true,
                      edit: true,
                    });

                    setName({ value: registries?.selected.name, error: "" });
                    setDescription({
                      value: registries?.selected.description,
                      error: "",
                    });
                    setVersion({
                      value: registries?.selected.service_version,
                      error: "",
                    });

                    setEndPoint({
                      value: registries?.selected.end_point,
                      error: "",
                    });
                  }}
                >
                  Edit service
                </Button>

                <Box ml={2} />
                <Button
                  className={classes.btn}
                  startIcon={<Cached />}
                  color="primary"
                  variant="outlined"
                  disableElevation
                  disabled={
                    token.saving ||
                    registries.selected.service_type == "INTERNAL"
                  }
                  onClick={() => {
                    refreshToken();
                  }}
                >
                  {token.saving ? (
                    <CircularProgress size={23} />
                  ) : (
                    "Refresh token"
                  )}
                </Button>
              </Box>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Service category"
                    secondary={registries?.selected.service_category}
                  />
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText
                    primary="Service type"
                    secondary={registries?.selected.service_type}
                  />
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText
                    primary="Service end point"
                    secondary={registries?.selected.end_point}
                  />
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText
                    primary="Service version"
                    secondary={registries?.selected.service_version}
                  />
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText
                    primary="Last call date"
                    secondary={
                      registries?.selected.last_call_date == null
                        ? "Unknown"
                        : registries?.selected.last_call_date
                    }
                  />
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText primary="Last call status" />
                  <ListItemSecondaryAction>
                    <Chip
                      avatar={
                        <Avatar>
                          {registries?.selected?.last_call_status ==
                          "SUCCESSFUL" ? (
                            <CheckCircle fontSize="small" />
                          ) : (
                            <Block fontSize="small" />
                          )}
                        </Avatar>
                      }
                      variant="outlined"
                      color={
                        registries?.selected?.last_call_status == "SUCCESSFUL"
                          ? "primary"
                          : "default"
                      }
                      size="small"
                      label={capitalize(
                        registries?.selected.last_call_status == null
                          ? "Unknown"
                          : registries?.selected.last_call_status
                      )}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider variant="middle" />
                <ListItem>
                  <ListItemText primary="Service status" />
                  <ListItemSecondaryAction>
                    <Chip
                      avatar={
                        <Avatar>
                          {registries?.selected.service_status.toLowerCase() ==
                          "enabled" ? (
                            <CheckCircle fontSize="small" />
                          ) : (
                            <Block fontSize="small" />
                          )}
                        </Avatar>
                      }
                      variant="outlined"
                      color={
                        registries?.selected.service_status.toLowerCase() ==
                        "enabled"
                          ? "primary"
                          : "default"
                      }
                      size="small"
                      label={capitalize(registries?.selected.service_status)}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Box>
          </Grid>
        ) : (
          <Grid item xs={12} md={5}>
            <Box flexGrow={1} pl={3}>
              <Typography variant="h5">
                Services discovery
                {/* {discoveries.data.length} */}
              </Typography>
            </Box>

            <List>
              {!discoveries.loading
                ? discoveries.data.map((d, i) => (
                    <ListItem
                      key={i}
                      dense
                      // selected={selectedRole.index == i}
                      // onClick={() => {
                      //   setSelectedRole({ index: i, role: role });
                      //   getPrivileges(accountData.token, role.role_id);
                      // }}
                    >
                      <ListItemText
                        primary={d.description}
                        secondary={d.http_status}
                      />
                      <ListItemSecondaryAction>
                        {d.discovery_status == "FOUND" ? (
                          <CheckCircle fontSize="small" color="primary" />
                        ) : (
                          <Close fontSize="small" color="error" />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))
                : Array.from(Array(discoveries.per_page).keys()).map(
                    (item, i) => (
                      <ListItem key={i}>
                        <ListItemText
                          primary={
                            <Skeleton
                              variant="text"
                              width={"100%"}
                              style={{ borderRadius: 7 }}
                            />
                          }
                        />
                      </ListItem>
                    )
                  )}
            </List>
            <Box width={1} pb={2} display="flex" justifyContent="center">
              <Pagination
                disabled={discoveries.loading}
                count={discoveries.pages}
                page={discoveries.page + 1}
                onChange={(e, v) => {
                  getDiscoveries(accountData.token, v - 1);
                }}
                size="large"
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default withLocalize(ServiceRegistry);
